export default __webpack_public_path__ + "static/media/rgs_main_mobile@2x.0d6946f9.jpg";